import type { FC } from 'react'

import * as Subnav from '@segment/matcha/recipes/Subnav'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

import type { SubnavigationDropdownItem } from './data'

const SubnavigationAnchor: FC<SubnavigationDropdownItem> = ({ label, id }) => {
  const scroll = useScrollToAnchor(id, -100)
  return (
    <Subnav.Item
      label={label}
      href={`#${id}`}
      aria-label={label}
      onClick={(e) => {
        e.preventDefault()
        scroll()
      }}
    />
  )
}

export default SubnavigationAnchor
